import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

export const customerDeclarantSchema = z.object({
  declarant: z.object({
    name: z.string().optional().nullable(),
    identificationNumber: z.string().optional().nullable(),
    identificationNumberIDMS: z.string().optional().nullable(),
    useImporterEORI: z.boolean().optional().nullable(),
    address: z.object({
      street: z.string().optional().nullable(),
      postcode: z.string().optional().nullable(),
      city: z.string().optional().nullable(),
      country: z.string().optional().nullable(),
    }),
    authorisedIdentity: z.string().optional().nullable(),
    contactPerson: z.object({
      name: z.string().optional().nullable(),
      phoneNumber: z.string().optional().nullable(),
      email: z.string().optional().nullable(),
    }),
  }),
});
export type CustomerViewDeclarantFormValues = z.infer<typeof customerDeclarantSchema>;

export const useCustomerViewDeclarantFormInitializer = ({ generalDeclarant, customerDetails }) => {
  const buildFormValues = (gd, cd) => {
    const { declarant: customerDetailsDeclarant } = cd || {};
    const isCreate = !customerDetails?._id;
    const declarant = isCreate ? gd : customerDetailsDeclarant;

    return {
      declarant: {
        name: declarant?.name || '',
        identificationNumber: declarant?.identificationNumber || '',
        identificationNumberIDMS: declarant?.identificationNumberIDMS || '',
        useImporterEORI: declarant?.useImporterEORI || false,
        address: {
          street: declarant?.address?.street || '',
          postcode: declarant?.address?.postcode || '',
          city: declarant?.address?.city || '',
          country: declarant?.address?.country || '',
        },
        authorisedIdentity: declarant?.authorisedIdentity || '',
        contactPerson: {
          name: declarant?.contactPerson?.name || '',
          phoneNumber: declarant?.contactPerson?.phoneNumber || '',
          email: declarant?.contactPerson?.email || '',
        },
      },
    };
  };

  const form = useForm<CustomerViewDeclarantFormValues>({
    initialValues: buildFormValues(generalDeclarant, customerDetails),
    validate: zodResolver(customerDeclarantSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
